import React, { useLayoutEffect, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import Sidebar from './Sidebar';
import { getUserProfile } from '../utils/apiService';

const Dashboard = () => {
      const [formData, setFormData] = useState({
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            address: '',
        });
      useEffect(() => {
            // Fetch user profile data on component mount
            const fetchUserData = async () => {
                const token = localStorage.getItem('token'); // Matches Login.js key
    
                if (!token) {
                    console.error('No authentication token found');
                    return;
                }
    
                const result = await getUserProfile(token);
    
                if (result && result.status) {
                    const userData = result.data || result.user; // Adjust based on your API response structure
                    setFormData({
                        firstName: userData.first_name || '',
                        lastName: userData.last_name || '',
                        email: userData.email || '',
                        phone: userData.phone || '',
                        address: userData.address || '',
                    });
                }
            };
    
            fetchUserData();
        }, []);
    
    return (
        <div className="wrapper position-relative">
            <Header />

            <div className="page-title">
                <div className="tf-container">
                    <div className="page-title-content text-center">
                        <h1 className="title split-text effect-right">
                            My Account
                        </h1>
                    </div>
                </div>
            </div>

            <div className="main-content">
                <section className="section-team p-team tf-spacing-2">
                    <div className="tf-container">
                        <div className="row rg-30">
                            <div className="col-lg-4 col-md-4">
                                <Sidebar />
                            </div>

                            <div className="col-lg-8 col-md-8">
                                <div className="info-box">
                                    <label>First name</label>
                                    <p>{formData.firstName}</p>
                                </div>

                                <div className="info-box">
                                    <label>Last name</label>
                                    <p>{formData.lastName}</p>
                                </div>
                                <div className="info-box">
                                    <label>Email ID</label>
                                    <p>{formData.email}</p>
                                </div>

                                <div className="info-box">
                                    <label>Phone number</label>
                                    <p>{formData.phone}</p>
                                </div>

                                <div className="info-box">
                                    <label>Default address</label>
                                    <p>
                                        {formData.address}
                                    </p>
                                </div>

                                <Link to="/editprofile" className="tf-btn style-border w-full justify-content-center mt-5">
                                    <span>Edit Profile</span>
                                    <i className="icon-arrow-right"></i>
                                </Link>
                            </div>

                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    );
};

export default Dashboard